import App from '/Users/jpdevries/Sites/jpdevries/portfolio/packages/portfolio/pages/_app.tsx';
window.__REX_APP__ = App;
